import { render } from "./dermatology_investigations.vue?vue&type=template&id=27db9f2c&scoped=true"
import script from "./dermatology_investigations.vue?vue&type=script&lang=js"
export * from "./dermatology_investigations.vue?vue&type=script&lang=js"

import "./dermatology_investigations.vue?vue&type=style&index=0&id=27db9f2c&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27db9f2c"]])

export default __exports__